import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import AdhocHoldOfCntrContMain from "presentation/view/container/AdhocHoldOfContainer/AdhocHoldOfCntrContMain";

CommonEntrypoint(<AdhocHoldOfCntrContMain />)